<template>
  <div>
    <NotificationReminderContainer :feature-name="NOTIFICATION_FEATURES_NAME.SYLLABUS_AUTOMATOR" />
  </div>
</template>

<script>
import NotificationReminderContainer from '@/src/components/Settings/notifications/NotificationReminderContainer.vue'
import NOTIFICATION_FEATURES_NAME from '@src/constants/notification-constants.js'
export default {
  components: {
    NotificationReminderContainer,
  },
  page: {
    title: 'Notification | Syllabus Template',
    meta: [
      {
        name: 'description',
        content: 'Syllabus Template Notification System',
      },
    ],
  },
  data() {
    return {
      NOTIFICATION_FEATURES_NAME,
    }
  },
}
</script>
